module.exports = __webpack_public_path__ + "img/ifsp-hortolandia.bfdca216.jpeg";